import { styled, SxProp } from 'dripsy';
import React, { Fragment } from 'react';
import {
  EdgeInsets,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';

import { IS_WEB } from '@utils';
import { BaseText } from '../common/BaseText';
import { ScrollView } from '../common/ScrollView';
import { BreadcrumbBar } from '../views/BreadcrumbBar';
import { ScreensNameType } from '@navigation';

const ScrollViewContainer = styled(ScrollView)({
  bg: '$background0',
  flex: 1,
});

function contentContainerStyle(props: EdgeInsets): SxProp {
  return {
    flexGrow: 1,
    pt: '$4',
    px: ['$6', '5%'],
    pb: props.bottom,
  };
}

export const WebTitle = styled(BaseText)({
  pt: '$5',
  pb: '$4',
  color: '$heading800',
  variant: 'text.xbig',
  fontWeight: 'semi',
});

export interface ISettingsLayoutProps {
  children: React.ReactNode;
  title: string;
  breadcrumbRoutes?: ScreensNameType[];
}

export function SettingsLayout({
  children,
  title,
  breadcrumbRoutes,
}: ISettingsLayoutProps) {
  const insets = useSafeAreaInsets();
  const withBreadcrumbs = !!breadcrumbRoutes;

  return (
    <ScrollViewContainer
      contentContainerSx={contentContainerStyle(insets)}
    >
      {IS_WEB && (
        <Fragment>
          {withBreadcrumbs && (
            <BreadcrumbBar routes={breadcrumbRoutes} />
          )}
          <WebTitle>{title}</WebTitle>
        </Fragment>
      )}
      {children}
    </ScrollViewContainer>
  );
}
